/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import Content from './Content/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/App/Form/Data/ProvideData/Location"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Location.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Location.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 text="Choose a location for the appointment:"
 marginTop={4}
 marginBottom={0}
/>
</div>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
{children}
</React.Fragment>)
}